//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { autocomplete } from '~/mixins/autocomplete'

export default {

    name: 'SearchBox',

    mixins: [autocomplete],

    props: {
        type: {
            type: String,
            default: 'location'
        },
    },

    data() {
        return {
            loadApi: false,
        }
    },

    created() {

        if(this.type === 'name'){
            this.searchType = 'name'
        } else {
            this.searchType = 'location'
        }

/*        if(process.client && !this.isCrawler) {
            this.loadApi = true
        }*/

    },

    mounted() {

        window.addEventListener('duskResult', this.onDuskResult)

    },

    methods: {

        onDuskResult(event) {

            const data = event.detail

            var country = data.code.toLowerCase();
            var countryName = data.name.toLowerCase()
            var countryNameSlug = this.$helper.url_slug(countryName);

            var routeParams = { name: 'search.type.country', params: { type: 'country', term: country, slug: countryNameSlug } }

            //console.log(routeParams)

            const resolved = this.$router.resolve(routeParams)
            const currentPath = this.$router.currentRoute.path

            if(resolved.route.path !== currentPath) {
                this.$router.push(routeParams)
            }
        },

    },

    computed: {

        isSearchLoading() {
            return this.$waiter.has('search.do')
        },

        isCrawler() {
            return this.$store.state.isCrawler
        },

    }
}

